const code = 'en'; export default { code }